import useGetUserIdentity from './useGetUserIdentity';

const useDirectDebitFeatures = (accountId: string) => {
  const { isOriginator, isBorrower } = useGetUserIdentity();
  return isOriginator || (isBorrower && !!accountId);
};

export default useDirectDebitFeatures;
